export default __webpack_public_path__ + "static/media/39.d859b6f1.png";